import styled, { css } from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  padding: 0 2.4rem;
  text-align: center;
  margin-top: 5.6rem;

  ${media.greaterThan('medium')`
    margin-top: 14rem;
  `}
`;

export const Title = styled.p`
  font-size: 3rem;
  line-height: 3.6rem;
  font-weight: 600;
  margin-bottom: 3rem;

  ${media.greaterThan('medium')`
    font-size: 4.8rem;
    line-height: 5.4rem;
  `}
`;

export const Name = styled.h2`
  font-size: 3.2rem;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.colors.blue};
`;

export const CardsRow = styled.div`
  display: flex;
  flex-direction: column;

  ${media.greaterThan('medium')`
    flex-direction: row;
    gap: 5rem;
  `}
`;

export const Card = styled.div<{ topBanner?: boolean }>`
  border: ${({ theme }) => `1px solid ${theme.colors.grayBorder}`};
  border-radius: 12px;
  text-align: center;
  padding: 2.4rem;
  margin: 2.4rem auto 3.2rem;

  display: flex;
  flex-direction: column;

  ${media.greaterThan<{ topBanner?: boolean }>('medium')`
    padding: ${({ topBanner }) => (topBanner ? '2rem 5.2rem' : '5.2rem')};
  `}

  ${({ topBanner }) =>
    topBanner &&
    css`
      &:before {
        content: 'o mais escolhido';
        position: relative;
        bottom: 4rem;
        background: ${({ theme }) => theme.colors.blue};
        width: 100%;
        border-radius: 2rem;
        color: ${({ theme }) => theme.colors.white};
        font-size: 1.4rem;
        line-height: 2rem;
        font-weight: 600;
        text-transform: uppercase;
        padding: 0.8rem;
      }
    `}
`;

export const PriceText = styled.span`
  font-weight: 600;
  line-height: 2.6rem;
  margin: 3.2rem auto 2.8rem;
`;

export const Price = styled(PriceText)`
  font-size: 3.6rem;
`;

export const SmallText = styled.span`
  font-size: 1.2rem;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.colors.gray2};
`;

export const List = styled.ul`
  text-align: start;
  list-style: disc outside none;
  margin: 2.4rem auto;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.gray1};
  margin-bottom: 1.6rem;
`;

export const Text = styled.p`
  font-size: 1.6rem;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.colors.gray2};
  margin-bottom: 0.8rem;
`;

export const TopText = styled.span`
  position: relative;
  bottom: 6.8rem;
  background: ${({ theme }) => theme.colors.blue};
  width: 100%;
  border-radius: 2rem;
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 600;
  text-transform: uppercase;
  padding: 0.8rem;
`;
